if not App.angularApp?
    return

App.angularApp.directive 'mfFpcMissing', [() ->
    restrict: 'A'
    require: '?ngModel'
    link: ($scope, element, attrs, ctrl) =>

        run = () =>
            # orange validation highlighting should NOT occur the first time the user visits the step,
            # nor if the user closed the browser or left the process without a save event (whether or
            # not the validation shows up should depend on whether or not the step has been saved, not
            # whether the user is in the add process or the edit process)
            return if $scope.service.savedSteps.indexOf($scope.service.currentStepName) is -1

            element.addClass 'fieldprint'

            if attrs.mfFpcMissing
                attr = attrs.mfFpcMissing
            else if attrs.ngModel
                attr = attrs.ngModel

            # There can be 3 cases for inputName:
            #
            # 1. service.fpcResult.data['input_name']
            # 2. service.fpcResult.data[inputName] // Where inputName == 'input_name'
            # 3. service.fpcResult.data.input_name
            #
            # In all cases, we want to get "input_name" as a string.

            if attr
                # Cases 1 and 2
                if match = attr.match(/\[([^\]]+)\]$/)
                    match = match[1]
                    if match = match.match(/^['"](.*)['"]$/)
                        # Case 1
                        inputName = match[1]
                    else
                        # Case 2
                        inputName = $scope.$parent.inputName
                else
                    # Case 3
                    if match = attr.match(/\.([^\.]+)$/)
                        inputName = match[1]

            # hacky way to get this working with management system
            if element[0] and element[0].id is 'mgmtSys'
                inputName = 'management_system'


            if not inputName
                throw Error("Fieldprint orange validation: Could not find input name for ng-model #{attrs.ngModel}")

            # I hate this
            $scope.service.updateCompletenessFor element, inputName

            # This don't work with ui-selects otherwise it would be amazing
            # element.attr 'ng-class', "{ 'missing': !service.fpcResult.completeness.inputs.#{inputName}}"
            # element.removeAttr 'mf-fpc-missing'

            # $compile(element)($scope)
            # Old crap that mostly works but kind of doesn't
            if $scope.service.fpcResult.completeness.inputs[inputName]? and not $scope.service.fpcResult.completeness.inputs[inputName]
                element.addClass 'missing'

        $scope.service.onDataLoaded $scope, () ->
            run()

        $scope.$watch attrs.mfFpcMissingTrigger, () =>
            run()

]
